"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateAccrualsResponse = exports.AccrualConfigData = exports.AccrualFrequencyTypes = void 0;
exports.AccrualFrequencyTypes = {
    Weekly: "Weekly",
    Bi_Weekly: "Bi-Weekly",
};
class AccrualConfigData {
    constructor() {
        this.enabled = true;
        this.frequency = exports.AccrualFrequencyTypes.Bi_Weekly;
    }
}
exports.AccrualConfigData = AccrualConfigData;
class GenerateAccrualsResponse {
    constructor(entry, accrual, accrualReversal, accruedDays, periodDays) {
        this.entry = entry;
        this.accrual = accrual;
        this.accrualReversal = accrualReversal;
        this.accruedDays = accruedDays;
        this.periodDays = periodDays;
    }
}
exports.GenerateAccrualsResponse = GenerateAccrualsResponse;
//# sourceMappingURL=Accruals.js.map